<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1"></div>
      <v-text-field
        v-if="allowSearch === true"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <div class="dividersClass">
      <v-data-table
        :headers="schema.headers"
        :items="schema.rows"
        item-key="name"
        :pagination.sync="pagination"
        :search="search"
      >
        <template v-slot:headers="props">
          <tr>
            <th v-if="schema.selectable == true"></th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <!-- <tr :active="props.item.selected" @click="props.item.selected= !props.item.selected" @dblclick="setResult(props.item)"> -->

          <tr
            @click="
              selectedIndex = props.index
              $emit('indexChange', props.item)
            "
          >
            <td v-if="schema.selectable == true">
              <v-checkbox
                :value="selectedIndex == props.index"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td
              v-for="(header, index) in schema.headers"
              :key="index"
              class="td"
              :class="header.textClass"
            >
              {{ props.item[header.value] }}
            </td>
            <td>
              <v-icon
                align-end
                @click="
                  selectedIndex = props.index
                  $emit('iconClicked', props.item)
                "
                >delete</v-icon
              >
            </td>
            <!-- xs-md-xl , left-center-right  -->
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'TableWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    allowSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filters: this.schema.filtersValues,
      pagination: this.schema.pagination || {},
      selectedIndex: -1,
      search: ''
    }
  },
  methods: {
    iconClicked() {
      console.log('ICON CLICKED!!!')
    },
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers)
      this.schema.filters.forEach(function(x) {
        cf.registerFilter(x.parameter, function(searchWord, items) {
          if (searchWord.trim() === '') return items
          return items.filter(function(item) {
            if (item[x.parameter] == undefined) return
            return item[x.parameter]
              .toLowerCase()
              .includes(searchWord.toLowerCase())
          }, searchWord)
        })
      })
      return cf.runFilters()
    },
    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val, parameter) {
      var obj = {}
      obj[parameter] = val
      this.filters = this.$MultiFilters.updateFilters(this.filters, obj)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    change(item) {
      item.selected = !item.selected
      console.log(item)
    }
  }
}
</script>

<style>
.elevation-1 td {
  border-left: 1px solid#858585;
}
.td {
  text-align: center;
}
/* table td + td { border-left:1px solid #858585; } */
</style>
